import { LOADED_EVENT } from './reveal.js';

// ロゴが浮き上がり切るまでの時間（_loading.scss の delay 0.3s + duration 1s）
const LOGO_SHOW_MS = 1300;
// ロゴが出きってから、フェードアウトを始めるまで見せておく時間
const LOGO_HOLD_MS = 500;
// 画像が読めなくてもローディングで止まらないようにする上限（ページ表示から）
const MAX_WAIT_MS = 8000;

function waitForImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
    if (img.complete) {
      resolve();
    }
  });
}

function waitForElement(img) {
  if (img.complete) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', resolve, { once: true });
  });
}

/**
 * KV エリアの画像（img 要素と背景画像）がすべて読み込まれるまで待つ。
 */
function waitForKvImages() {
  const kv = document.querySelector('.p-kv');
  if (!kv) {
    return Promise.resolve();
  }

  const tasks = [...kv.querySelectorAll('img')].map(waitForElement);

  kv.querySelectorAll('*').forEach((el) => {
    const match = getComputedStyle(el).backgroundImage.match(/url\(["']?(.+?)["']?\)/);
    if (match) {
      tasks.push(waitForImage(match[1]));
    }
  });

  return Promise.all(tasks);
}

/**
 * ロゴ画像の読み込み（とデコード）が終わってからロゴを表示し、見せきるまで待つ。
 */
async function showLogo(loading) {
  const logo = loading.querySelector('.c-loading__logo');

  if (logo) {
    await waitForElement(logo);
    if (logo.decode) {
      await logo.decode().catch(() => {});
    }
  }

  // 読み込み済みでもトランジションが走るよう、1 フレーム置いてからクラスを付ける
  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  loading.classList.add('is-logo-shown');

  await delay(LOGO_SHOW_MS + LOGO_HOLD_MS);
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function initLoading() {
  const loading = document.querySelector('.js-loading');
  if (!loading) {
    return;
  }

  // KV 画像の読み込みはロゴ表示と並行して進める
  const kvReady = waitForKvImages();

  Promise.race([
    Promise.all([showLogo(loading), kvReady]),
    delay(Math.max(0, MAX_WAIT_MS - performance.now())),
  ]).then(() => {
    loading.classList.add('is-loaded');
    document.dispatchEvent(new CustomEvent(LOADED_EVENT));
    loading.addEventListener(
      'transitionend',
      (event) => {
        if (event.target === loading) {
          loading.remove();
        }
      },
    );
  });
}
